// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pages-news-index-list-bpzwt{display:grid;grid-gap:24px}.pages-news-index-list-bpzwt.pages-news-index-desktop-zsloj{grid-template-columns:repeat(4,1fr)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"list": "pages-news-index-list-bpzwt",
	"desktop": "pages-news-index-desktop-zsloj"
};
module.exports = ___CSS_LOADER_EXPORT___;
